import styled from 'styled-components'
import { ButtonNew as Button } from '@purecarslabs/signal-components/Button'
import Typography from '@purecarslabs/signal-components/Typography'
import {
  colorBlackSelector,
  colorWhiteSelector,
  getColorPrimarySelector,
  getColorTextSelector,
  getSpacingSelector
} from '@purecarslabs/signal-theme/selectors'
import { FORM_MAX_WIDTH_PX } from '@app-src/constants'
import { MvhColorsType } from '@app-src/types'

export const EmbedWrapper = styled.div<{
  $mvhColors?: MvhColorsType | null
  $isLightTextColor: boolean
  $submissionComplete: boolean
}>`
  * {
    font-family: 'PC LeadForms Custom Font Normal', 'Source Sans', sans-serif;
  }

  color: ${({ $mvhColors }) => $mvhColors?.textColor || getColorTextSelector()};
  margin-bottom: 32px;

  form {
    transition: height 1s, margin 1s;
    ${({ $submissionComplete }) =>
      $submissionComplete
        ? 'height: 0px !important; margin: 0; overflow: hidden;'
        : 'margin: 48px 0 24px 0;'}
  }

  .submit-choice:not(.Mui-disabled),
  .submit-choice:not(.Mui-disabled):hover {
    background: ${({ $mvhColors }) =>
      $mvhColors?.submitButtonColor || getColorPrimarySelector()};
    color: ${({ $mvhColors }) =>
      $mvhColors?.submitButtonTextColor || colorWhiteSelector};

    span {
      font-family: 'PC LeadForms Custom Font Bold',
        'PC LeadForms Custom Font Normal', 'Source Sans', sans-serif;
    }
  }

  .MuiSwitch-switchBase {
    color: ${({ $mvhColors }) =>
      $mvhColors?.submitButtonColor || getColorPrimarySelector()};
  }

  .MuiSwitch-track {
    background-color: ${({ $mvhColors }) =>
      $mvhColors?.submitButtonColor || getColorPrimarySelector()} !important;
  }

  ${props =>
    props.$isLightTextColor
      ? `
    .terms-toggle {
      color: ${colorBlackSelector(props)}
    }`
      : ''}
`

export const SubmissionCompleteWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${getSpacingSelector(2)}px;
  max-width: ${FORM_MAX_WIDTH_PX}px;
`

export const SubmissionCompleteTypography = styled(Typography).attrs(() => ({
  variant: 'body1'
}))`
  font-family: 'PC LeadForms Custom Font Bold',
    'PC LeadForms Custom Font Normal', 'Source Sans', sans-serif;
`

export const SubmitWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: ${FORM_MAX_WIDTH_PX}px;

  @media only screen and (max-width: 480px) {
    flex-direction: column;
    align-items: center;

    & > button {
      margin-bottom: 10px;
    }
  }
`

export const SubmitButton = styled(Button).attrs(() => ({
  disableRipple: true,
  className: 'submit-choice',
  variant: 'contained'
}))`
  margin-right: 20px;
  box-sizing: border-box;

  @media only screen and (max-width: 480px) {
    width: 100%;
    margin-right: 0;
  }
`

export const PriceDropWrapper = styled.div<{ $includePriceDrops: boolean }>`
  display: flex;
  align-items: center;

  .MuiSwitch-root {
    opacity: ${({ $includePriceDrops }) => ($includePriceDrops ? '1' : '0.4')};
    margin-right: -8px;
  }
`

export const PriceDropTypography = styled(Typography).attrs(() => ({
  variant: 'body1'
}))`
  text-align: right;

  @media only screen and (max-width: 480px) {
    font-weight: normal;
    font-size: 14px;
  }
`
